import React, {useRef, useState, useCallback, useEffect} from 'react';
import {sleep} from 'utils/sleep.js';
import {getBarWidth} from './getBarWidth.js';
import {getStepFromPosition} from './getStepFromPosition.js';
import {getWindowedEvents} from './getWindowedEvents.js';

export const useScroll = ({
    ref,
    sequencerEngine,
    resolution,
    events,
    xScale,
    getEvents,
    widthExtension=700,
    eventsLength
}) => {
    const [visibleView, setVisibleView] = useState({start: undefined, end: undefined, preWidth: 0});
    const lastScrollLeft = useRef(undefined);
    const lastXScale = useRef(undefined);

    useEffect(() => {
        if (!ref) {
            return undefined;
        }
        ref.current.addEventListener(
            'scroll', onScroll);

        return () => ref.current ?
            ref.current.removeEventListener(
            'scroll', onScroll) : undefined;
    }, [setVisibleView, ref, resolution, visibleView, events]);

    useEffect(() => {
        if (events) {
            onScroll();
        }
    }, [events]);

    const onScroll = useCallback(async (e) => {
        if (!ref || !ref.current) {
            return;
        }
        let xScale = sequencerEngine.state.arrangement.xScale;
        let scrollLeft = ref.current.scrollLeft;
        if (lastXScale.current === xScale &&
            lastScrollLeft.current === scrollLeft) {
            return;
        }
        lastXScale.current = xScale;
        lastScrollLeft.current = scrollLeft;

        let width = ref.current.clientWidth;
        let start = getStepFromPosition(
            Math.max(0,scrollLeft - widthExtension / 2.0),
            resolution,
            undefined,
            xScale);
        let duration = getStepFromPosition(width + 1.5 * widthExtension, resolution, undefined, xScale);
        let end = start + duration;
        let _patternSwitchEvents = events || getEvents() || [];
        let eventsToShow = getWindowedEvents(_patternSwitchEvents, start, end);
 
        let startIndex = Math.max(0, _patternSwitchEvents.indexOf(first(eventsToShow)) - 1);
        let endIndex = _patternSwitchEvents.indexOf(last(eventsToShow)) + 4;

        let preDuration = _patternSwitchEvents[startIndex] ? _patternSwitchEvents[startIndex].step : 0;
        let preWidth = getBarWidth(preDuration, resolution, xScale);
        if (startIndex !== visibleView.start ||
            endIndex !== visibleView.end ||
            visibleView.preWidth !== preWidth) {
            setVisibleView({
                start: startIndex,
                end: endIndex,
                preWidth});
        }
    }, [setVisibleView, ref, resolution, visibleView, events]);

    useEffect(() => {
        onScroll();
    }, [ref, eventsLength]);

    return {visibleView};
};


const first = (a) => a[0];
const last = (a) => a[a.length - 1];
 
